module.exports = __webpack_public_path__ + "assets/6c0386d1f78b3c32a7975d83e634bd1a.png";